import { formatDateMoment } from 'utils/utils'
import { Button } from 'avo-ui'
import icAddSquare from 'assets/images/ic-add-square.svg'

export const TAB_MANIFEST = ['pengemasan', 'print surat jalan', 'tanpa resi']

export const TABLE_MANIFEST = {
    name: 'Orders',
    column: [
        {
            name: 'Nomor Pesanan',
            key: 'order_code',
            render: ({ value }) => <div className={'font-medium text-blue-90'}>{value}</div>,
        },
        {
            name: 'Alamat Pengiriman',
            render: ({ item }) => (
                <div>
                    <div className={'font-medium'}>{item.shipping_name}</div>
                    <div>{item?.shipping_address}</div>
                </div>
            ),
        },
        {
            name: 'Ekspedisi',
            render: ({ item }) => (
                <div className={'flex flex-row gap-4 items-center'}>
                    <img className={'w-12'} src={item?.shipping_image_url} alt='Ekspedisi' />
                    <div>
                        <div className={'font-medium'}>{item.shipping_service}</div>
                        <div>{item?.shipping_route}</div>
                    </div>
                </div>
            ),
        },
        {
            name: 'Grand Total',
            key: 'grand_total',
        },
        {
            name: 'Nomor Resi',
            key: 'awb',
        },
        {
            name: 'Tanggal Order',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
        {
            name: 'Action',
            key: 'action',
            width: 150,
            render: ({ item, onClickItem }) => (
                <Button type={'outline'} icon={icAddSquare} title={'Add AWB'} onClick={() => onClickItem(item)} />
            ),
        },
    ],
}

export const FILTER_MANIFEST = [
    {
        title: 'Ekspedisi',
        key: 'shipping_aliases',
        list: [],
    },
]
